import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {NavbarComponent} from './navbar/navbar.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {NjoyCommonModule} from "../shared/modules/njoy-common/njoy-common.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NjoyCommonModule
    ],
    declarations: [
        NavbarComponent,
        SidebarComponent
    ],
    exports: [
        NavbarComponent,
        SidebarComponent
    ]
})
export class ComponentsModule {
}
